import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'jb-bff-skeleton',
  templateUrl: './bff-skeleton.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BffSkeletonComponent {}
